import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectPrescriptionViewSettingsData } from 'src/clinic/reducers/prescription/prescriptionReducer'
import { fetchPrescriptionViewSettings } from 'src/clinic/reducers/prescription/services/prescriptionViewSettingsThunk'
import { defaultConfirmationModalProps } from 'src/consumer/helpers/utilFunctions'
import usePrescriptionTemplateApiActions from 'src/mentor/components/MentorPrescriptionTemplates/components/hooks/usePrescriptionTemplateApiActions'
import { usePrescriptionTemplateHandlers } from 'src/mentor/components/MentorPrescriptionTemplates/components/hooks/usePrescriptionTemplateHandlers'

export default function usePrescriptionTemplateFormStates({
  clinicBrands,
  clinicId,
  mentorClinicAssociationData,
  mentorProfileData,
}) {
  const dispatch = useDispatch()

  const [paperPrescriptionTemplate, setPaperPrescriptionTemplate] = useState()
  const [pdfPrescriptionTemplate, setPdfPrescriptionTemplate] = useState()
  const [pdfOptions, setPdfOptions] = useState()
  const [paperOptions, setPaperOptions] = useState()
  const [prescriptionTemplateType, setPrescriptionTemplateType] = useState('print')
  const [confirmationModalProps, setConfirmationModalProps] = useState(
    defaultConfirmationModalProps,
  )
  const handlers = usePrescriptionTemplateHandlers(
    prescriptionTemplateType === 'print'
      ? setPaperPrescriptionTemplate
      : setPdfPrescriptionTemplate,
  )

  const {
    getAndSetPrescriptionTemplate,
    loading,
    handleSubmit,
    savePrescriptionTemplate,
    addTemplate,
    deleteTemplate,
    activateTemplate,
  } = usePrescriptionTemplateApiActions({
    clinicBrands,
    clinicId,
    mentorClinicAssociationData,
    mentorProfileData,
    setPaperOptions,
    setPdfOptions,
    paperPrescriptionTemplate,
    setPaperPrescriptionTemplate,
    pdfPrescriptionTemplate,
    setPdfPrescriptionTemplate,
    setConfirmationModalProps,
    selectedTemplateType: prescriptionTemplateType,
  })

  const prescriptionViewSettingsData = useSelector(selectPrescriptionViewSettingsData)
  const prescriptionViewSettings = prescriptionViewSettingsData?.data || {}
  const paperPrintSettings = prescriptionViewSettings.paperPrintSettings || {}
  const headerSettings = paperPrintSettings?.headerSettings || {}
  const footerSettings = paperPrintSettings?.footerSettings || {}
  function setupTemplateUsingPrescriptionViewSettings(newTemplateData) {
    if (prescriptionViewSettings) {
      setPaperPrescriptionTemplate((prev) => {
        const prevTemplate = newTemplateData || prev || {}
        const showQr =
          prevTemplate?.patientInfoSectionSettings?.showQrCode ??
          prescriptionViewSettings?.showPrescriptionQR

        return {
          ...prevTemplate,
          header: {
            ...(prevTemplate?.header ?? {}),
            customHeaderHeight:
              prevTemplate?.header?.customHeaderHeight ?? headerSettings?.headerHeight,
            customHeaderType: prevTemplate?.header?.customHeaderType ?? headerSettings?.headerStyle,
            customHeaderBlank:
              prevTemplate?.header?.customHeaderBlank ?? headerSettings?.showBlankHeader,
          },
          footer: {
            ...(prevTemplate?.footer ?? {}),
            customFooterHeight:
              prevTemplate?.footer?.customFooterHeight ?? footerSettings?.footerHeight,
            customFooterType: prevTemplate?.footer?.customFooterType ?? footerSettings?.footerStyle,
            customFooterBlank:
              prevTemplate?.footer?.customFooterBlank ?? footerSettings?.showBlankFooter,
          },
          margins: {
            ...(prevTemplate?.margins ?? {}),
            marginTop: prevTemplate?.margins?.marginTop ?? paperPrintSettings?.marginTop,
            marginRight: prevTemplate?.margins?.marginRight ?? paperPrintSettings?.marginRight,
            marginBottom: prevTemplate?.margins?.marginBottom ?? paperPrintSettings?.marginBottom,
            marginLeft: prevTemplate?.margins?.marginLeft ?? paperPrintSettings?.marginLeft,
          },
          patientInfoSectionSettings: {
            ...(prevTemplate?.patientInfoSectionSettings || {}),
            showQRCode: showQr,
          },
        }
      })
    }
  }

  useEffect(() => {
    setupTemplateUsingPrescriptionViewSettings()
  }, [prescriptionViewSettings])

  //   useEffect(() => {
  //     setupTemplateUsingPrescriptionViewSettings(prescriptionTemplateData)
  //   }, [prescriptionTemplateData])

  // Removed console.log for performance - it logs entire template on every render

  useEffect(() => {
    dispatch(fetchPrescriptionViewSettings())
  }, [dispatch])

  useEffect(() => {
    getAndSetPrescriptionTemplate()
  }, [clinicId])

  return {
    handlers,
    printPreviewType: prescriptionTemplateType,
    setPrintPreviewType: setPrescriptionTemplateType,
    paperPrescriptionTemplate,
    setPaperPrescriptionTemplate,
    pdfPrescriptionTemplate,
    setPdfPrescriptionTemplate,
    pdfOptions,
    paperOptions,
    paperPrintSettings,
    addTemplate,
    deleteTemplate,
    activateTemplate,
    confirmationModalProps,
    setConfirmationModalProps,
    handleSubmit,
    savePrescriptionTemplate,
    loading,
  }
}
